import { ALL_COUNTS, FILTER_COUNTS, SEARCH_COUNTS, CLEAR_FILTER_COUNTS, ALERT_SESSION } from "../action-types.js";
import axios from "axios"
import {url, urlFront} from "../../App.js";


export const getAllCounts = () => {
    return async (dispatch) => {
        try {
            const config = {
                method: 'get',
                url: `${url}/counts/`,
                headers: {
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
            };
            const response = await axios(config)
            dispatch({
                type: ALL_COUNTS,
                payload: response.data
            })
        } catch (error) {
            const errorResponse = {};
            errorResponse.error = error.message;
            if(error.response.status === 401) {
                dispatch({
                    type: ALERT_SESSION,
                    payload: true
                })

                setTimeout(() => {
                    localStorage.clear('globalState')
                    window.location.replace(urlFront)
                }, [3000])
                
            }
            return errorResponse;    
        }
    } 
}
export const getFilterCounts = (filtros) => {
    return async (dispatch) => {
        try {
            const config = {
                method: 'post',
                url: `${url}/counts/filter`,
                headers: {
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
                data: filtros
            };
            const response = await axios(config)
            if (response.status === 200) {
                dispatch({
                    type: FILTER_COUNTS,
                    payload: response.data.elements
                })
            }
            else if (response.status === 204) {
                dispatch({
                    type: FILTER_COUNTS,
                    payload: ["Sin resultados"]
                })
            }
        } catch (error) {
            const errorResponse = {};
            errorResponse.error = error.message;
            if(error.response.status === 401) {
                dispatch({
                    type: ALERT_SESSION,
                    payload: true
                })

                setTimeout(() => {
                    localStorage.clear('globalState')
                    window.location.replace(urlFront)
                }, [3000])
                
            }  
            return errorResponse;    
        } 
    }
}
export const getSearchCounts = (partialId) => {
    return async (dispatch) => {
        try {
            const config = {
                method: 'post',
                url: `${url}/counts/search`,
                data: {
                    description: partialId
                },
                headers: {
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
            };
            const response = await axios(config)
            if (response.status === 200) {
                dispatch({
                    type: SEARCH_COUNTS,
                    payload: response.data.elements
                })
            }
            else if (response.status === 204) {
                dispatch({
                    type: SEARCH_COUNTS,
                    payload: ["Sin resultados"]
                })
            }
        } catch (error) {
            const errorResponse = {};
            errorResponse.error = error.message;
            if(error.response.status === 401) {
                dispatch({
                    type: ALERT_SESSION,
                    payload: true
                })

                setTimeout(() => {
                    localStorage.clear('globalState')
                    window.location.replace(urlFront)
                }, [3000])
                
            }  
            return errorResponse;    
        } 
    }
}

export const clearFilterCounts = () => {
    return {
      type: CLEAR_FILTER_COUNTS,
    };
  };